import { render, staticRenderFns } from "./RepairInventory.vue?vue&type=template&id=2890e3db"
import script from "./RepairInventory.vue?vue&type=script&lang=js"
export * from "./RepairInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports